import { OptionType } from "./types";

export interface Tq2DesignDetailsM {
  alternateHoldLoading: string;
  portBallastHoldNumber: { value: string; label: string } | null;
  seaBallastHoldNumber: { value: string; label: string } | null;
  ballastWaterTreatmentSystem: string;
  requiredSalinityOfWater: string;
  isTheSystemAbleToWorkInFreshWater: string;
  ballstingRateUsing: string;
  ballastPumps: string;
  ballastPumpsWaterTreatment: string;
  deBallstingRateUsing: string;
  deBallastPumps: string;
  deballastPumpsWaterTreatment: string;
  shipHasEedi: string;
  eediEvdiVrefSpeed: string;
  eediEvdirating: string;
  fittedWithShaftPowerMeter: string;
  fittedWithThatisAutomaticallyRecording: string;
  sensorsAndDataAcquistionSystemMaker: string;
  fittedWithMassFlowMetersToMeasureFuelConsumption: string;
  scrubberFitted: string;
  scrubberType: { value: string; label: string } | null;
  scrubberMaker: string;
  noxTierIIIEngineFuelGrade: string;
  holdTimeDaysorHours: string;
  noofCementHoles: string;
  dimensionsOfCementHoles: string;
  isVesselAuxBoilerConnectedToScrubber: string;
}

export const designDetailsFormInit = {
  alternateHoldLoading: "",
  portBallastHoldNumber: { value: "", label: "" },
  seaBallastHoldNumber: { value: "", label: "" },
  ballastWaterTreatmentSystem: "",
  requiredSalinityOfWater: "",
  isTheSystemAbleToWorkInFreshWater: "",
  ballstingRateUsing: "",
  ballastPumps: "",
  ballastPumpsWaterTreatment: "",
  deBallstingRateUsing: "",
  deBallastPumps: "",
  deballastPumpsWaterTreatment: "",
  shipHasEedi: "",
  eediEvdiVrefSpeed: "",
  eediEvdirating: "",
  fittedWithShaftPowerMeter: "",
  fittedWithThatisAutomaticallyRecording: "",
  sensorsAndDataAcquistionSystemMaker: "",
  fittedWithMassFlowMetersToMeasureFuelConsumption: "",
  scrubberFitted: "",
  scrubberType: { value: "", label: "" },
  scrubberMaker: "",
  noxTierIIIEngineFuelGrade: "",
  holdTimeDaysorHours: "",
  noofCementHoles: "",
  dimensionsOfCementHoles: "",
  isVesselAuxBoilerConnectedToScrubber: "",
};

export function mapSqlToTq2DesignDetailsForm(_designDetials: any): Tq2DesignDetailsM {
  return {
    alternateHoldLoading: _designDetials?.ALTERNATE_HOLD_LOADING || "",
    portBallastHoldNumber: {
      value: _designDetials?.PORT_BALLAST_HOLD_NUMBER_VAL || "",
      label: _designDetials?.PORT_BALLAST_HOLD_NUMBER_LBL || "",
    },
    seaBallastHoldNumber: {
      value: _designDetials?.SEA_BALLAST_HOLD_NUMBER_VAL || "",
      label: _designDetials?.SEA_BALLAST_HOLD_NUMBER_LABEL || "",
    },
    ballastWaterTreatmentSystem: _designDetials?.BALLAST_WATER_TREATMENT_SYSTEM || "",
    requiredSalinityOfWater: _designDetials?.REQUIRED_SALINITY_OF_WATER || "",
    isTheSystemAbleToWorkInFreshWater: _designDetials?.IS_THE_SYSTEM_ABLE_TO_WORK_IN_FRESH_WATER || "",
    ballstingRateUsing: _designDetials?.BALLSTING_RATE_USING || "",
    ballastPumps: _designDetials?.BALLAST_PUMPS || "",
    ballastPumpsWaterTreatment: _designDetials?.BALLAST_PUMPS_WATER_TREATMENT || "",
    deBallstingRateUsing: _designDetials?.DEBALLSTING_RATE_USING || "",
    deBallastPumps: _designDetials?.DEBALLAST_PUMPS || "",
    deballastPumpsWaterTreatment: _designDetials?.DEBALLAST_PUMPS_WATER_TREATMENT || "",
    shipHasEedi: _designDetials?.SHIP_HAS_EEDI || "",
    eediEvdiVrefSpeed: _designDetials?.EEDI_EVDI_VREF_SPEED || "",
    eediEvdirating: _designDetials?.EEDI_EVDI_RATING || "",
    fittedWithShaftPowerMeter: _designDetials?.FITTED_WITH_SHAFT_POWER_METER || "",
    fittedWithThatisAutomaticallyRecording: _designDetials?.FITTED_WITH_THAT_IS_AUTOMATICALLY_RECORDING || "",
    sensorsAndDataAcquistionSystemMaker: _designDetials?.SENSORS_AND_DATA_ACQUISTION_SYSTEM_MAKER || "",
    fittedWithMassFlowMetersToMeasureFuelConsumption:
      _designDetials?.FITTED_WITH_MASS_FLOW_METERS_TO_MEASURE_FUEL_CONSUMPTION || "",
    scrubberFitted: _designDetials?.SCRUBBER_FITTED || "",
    scrubberType: {
      value: _designDetials?.SCRUBBER_TYPE_VAL || "",
      label: _designDetials?.SCRUBBER_TYPE_LBL || "",
    },
    scrubberMaker: _designDetials?.SCRUBBER_MAKER || "",
    noxTierIIIEngineFuelGrade: _designDetials?.NOX_TIER_III_ENGINE_FUEL_GRADE || "",
    holdTimeDaysorHours: _designDetials?.HOLD_TIME_DAYS_OR_HOURS || "",
    noofCementHoles: _designDetials?.NO_OF_CEMENT_HOLES || "",
    dimensionsOfCementHoles: _designDetials?.DIMENSIONS_OF_CEMENT_HOLES || "",
    isVesselAuxBoilerConnectedToScrubber:
      _designDetials?.IS_VESSEL_AUX_BOILER_CONNECTED_TO_SCRUBBER || "",
  };
}

export const portBallastHoldNumberOptions: OptionType[] = [
  { value: "na", label: "N/A" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
];

export const seaBallastHoldNumberOptions: OptionType[] = [
  { value: "na", label: "N/A" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
  { value: "6", label: "6" },
  { value: "7", label: "7" },
];

export const scrubberTypeOptions: OptionType[] = [
  { value: "OpenLoop", label: "Open Loop" },
  { value: "ClosedLoop", label: "Closed Loop" },
  { value: "Hybrid", label: "Hybrid" },
];
